import { Link, useLocation } from 'react-router-dom'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/utils/shadcn'
import { routes } from '@/routes/utils'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

const itemClass = (active: boolean) =>
  cn(
    'text-sm transition-colors',
    active ? 'font-semibold text-gray-900' : 'font-medium text-gray-500 hover:text-gray-900',
  )

/**
 * Sub-navigation for the Interventiedesk, matching the wireframe:
 * Dashboard · Aanvragen · Medewerkers (Met leidinggevenden) · Facturatie.
 */
export const InterventionNav = () => {
  const { pathname } = useLocation()

  const dashboardPath = routes.interventionDashboard.getPath()
  const listPath = routes.interventionList.getPath()
  const employeesPath = routes.interventionEmployees.getPath()
  const managersPath = routes.interventionManagers.getPath()
  const billingPath = routes.interventionBilling.getPath()

  const isDashboard = pathname === dashboardPath
  const isMedewerkers = pathname === employeesPath || pathname === managersPath
  const isBilling = pathname.startsWith(billingPath)
  // Everything else inside this layout is an "Aanvragen" screen (list, detail, wizard).
  const isAanvragen = !isDashboard && !isMedewerkers && !isBilling

  return (
    <nav className="flex flex-wrap items-center gap-6 border-b border-gray-200 pb-3">
      <Link to={dashboardPath} className={itemClass(isDashboard)}>
        Dashboard
      </Link>
      <Link to={listPath} className={itemClass(isAanvragen)}>
        Aanvragen
      </Link>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className={cn('inline-flex items-center gap-1', itemClass(isMedewerkers))}
          >
            Medewerkers
            <ChevronDown className="h-3.5 w-3.5 opacity-60" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="min-w-[11rem]">
          <DropdownMenuItem asChild>
            <Link to={employeesPath} className="w-full cursor-pointer">
              Medewerkers
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to={managersPath} className="w-full cursor-pointer">
              Leidinggevenden
            </Link>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Link to={billingPath} className={itemClass(isBilling)}>
        Facturatie
      </Link>
    </nav>
  )
}

export default InterventionNav
